import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';


/**
 * @author Tari
 * @dateCreated 14 Jun 2023
 * @description esl-empty component class
 * @modifiedBy Tari
 * @dateModified 27 Jul 2023
 */
@Component({
  selector: 'esl-empty',
  templateUrl: './esl-empty.component.html',
  styleUrls: ['./esl-empty.component.scss']
})
export class EslEmptyComponent implements OnInit {

  @Input() imgType: "illustration" | "icon" = "illustration";
  @Input() title: string = "This section has no items yet";
  @Input() description: string = "Add items to see them here";
  @Input() moreInfo: string = "";
  @Input() hasPositiveAction: boolean = false;
  @Input() hasNegativeAction: boolean = false;
  @Input() positiveButtonText: string = "Continue";
  @Input() negativeButtonText: string = "Cancel";
  @Input() forceSmallScreen = false;
  @Output() positiveButtonClicked = new EventEmitter();
  @Output() negativeButtonClicked = new EventEmitter();
  constructor() { }

  ngOnInit(): void {
  }

}
